<template>
  <app-button text="Download All"
              button-style="accent"
              :class="$style.button"
              @click="onClick($event)">
    <app-svg-icon name="ic_download"
                  :class="$style.icon"/>
  </app-button>
</template>

<script>
export default {
  methods: {
    onClick(e) {
      this.$emit('click', e);
    },
  },
};
</script>

<style lang="scss" module>
.button {
  padding: 10px 45px 10px 58px;
  position: relative;

  .icon {
    position: absolute;
    left: 32px;
    top: 12px;
    width: 15px;
    height: 16px;
  }
}
</style>
